/** Placeholder the HTML server replaces on each document response. */
export const CSP_NONCE_PLACEHOLDER = '{{CSP_NONCE}}';

/**
 * Reads the per-request CSP nonce Vite stamps on
 * `meta[property=csp-nonce]`.
 *
 * The HTML server replaces {@link CSP_NONCE_PLACEHOLDER} before the
 * document is sent. A leftover placeholder means this page was served as
 * a static file, so callers must not pin Maps to a nonce the policy does
 * not contain.
 *
 * @returns The nonce for this document, or `undefined` when there is none.
 */
export function readCspNonce(): string | undefined {
  if (typeof document === 'undefined') {
    return undefined;
  }

  const meta = document.querySelector('meta[property="csp-nonce"]');
  if (!meta) {
    return undefined;
  }

  const fromIdl = meta instanceof HTMLElement ? meta.nonce : '';
  const nonce = fromIdl || meta.getAttribute('nonce') || '';
  if (nonce === '' || nonce === CSP_NONCE_PLACEHOLDER) {
    return undefined;
  }

  return nonce;
}
